import { LatestAnalyses, NewAnalysisHost } from "@amtana/analysis-client";
import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { ANALYSIS_CATALOGS } from "./model/analysis-copy.ts";
import { ANALYSIS_ERROR_COPY } from "./model/analysis-error-copy.ts";

export const analysisBrowserModule: BrowserModule = defineBrowserModule("analysis")
  .withErrorCopy(ANALYSIS_ERROR_COPY)
  .withScreens({
    manager: {
      path: "/analysis-manager",
      title: phrase(ANALYSIS_CATALOGS, "screenTitleManager"),
      layout: "app",
      load: () => import("./ui/sections/analysis-manager-screen.tsx"),
    },
    create: {
      path: "/analysis/new",
      title: phrase(ANALYSIS_CATALOGS, "screenTitleCreate"),
      layout: "app",
      load: () => import("./ui/sections/new-analysis-screen.tsx"),
    },
    detail: {
      path: "/analysis/:analysisId",
      title: phrase(ANALYSIS_CATALOGS, "screenTitleDetail"),
      layout: "app",
      load: () => import("./ui/sections/analysis-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "analyses",
      group: "leads",
      label: phrase(ANALYSIS_CATALOGS, "navAnalyses"),
      href: "/analysis-manager",
      icon: "chart",
      order: 100,
      activeFor: ["/analysis/"],
    },
  ])
  .withLends([
    { token: NewAnalysisHost, load: () => import("./ui/sections/new-analysis-host.tsx") },
    { token: LatestAnalyses, load: () => import("./ui/sections/latest-analyses.tsx") },
  ]);
